import React, { useState } from 'react'; 

import Form from './SigninForm'
import '../../CSS/Style.css'
const Signin = () => { 
	return ( 
		<div className='first_sec_ran'>
		<div className='container'> 
        <Form/>
		</div> 
		</div> 
	); 
} 
export default Signin;